import { render, staticRenderFns } from "./PromoterOrder.vue?vue&type=template&id=077464fa&scoped=true&"
import script from "./PromoterOrder.vue?vue&type=script&lang=js&"
export * from "./PromoterOrder.vue?vue&type=script&lang=js&"
import style0 from "./PromoterOrder.vue?vue&type=style&index=0&id=077464fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077464fa",
  null
  
)

export default component.exports